// extracted by mini-css-extract-plugin
module.exports = {"pageRootContainer":"slug_pageRootContainer__8s4Zc"};